import {
  IBlogEntry,
  IBox,
  INewsletterFormData,
  IQuickLink,
  ISlide,
  ISocialMedia,
} from '../../common/interfaces/frontpage.interface';
import {
  IApiBlogEntry,
  IApiBox,
  IApiNewsletterFormData,
  IApiQuickLink,
  IApiSlide,
  IApiSocialMedia,
} from '../../common/interfaces/api.interface';

export default class FrontpageHelper {
  public static isElemVisible(el: HTMLElement, buffer = 200): boolean {
    if(!el) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top + buffer;
    const elemBottom = rect.bottom;
    return elemTop < window.innerHeight && elemBottom >= 0;
  }

  public static transformNewsletterFormData(data: INewsletterFormData): IApiNewsletterFormData {
    return {
      action: `anmelden`,
      clientIP: ``,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      salutationId: data.gender,
    };
  }

  public static transformApiBlogEntryToBlogEntry(apiBlogEntry: IApiBlogEntry, link?: string): IBlogEntry {
    return {
      externalLink: apiBlogEntry.externalLink,
      imageUrl: `${apiBlogEntry.imageUrl}?w=580&auto=format`,
      link: link ?? apiBlogEntry.pageLink ?? `#`,
      locizeIdentifier: apiBlogEntry.locizeIdentifier,
    };
  }

  public static transformApiBoxToBox(apiBox: IApiBox, link?: string): IBox {
    return {
      backgroundImage: `${apiBox.backgroundImage}?w=350`,
      externalLink: apiBox.externalLink,
      hoverImage: `${apiBox.hoverImage}?w=350`,
      link: link ?? apiBox.pageLink ?? `#`,
      locizeIdentifier: apiBox.locizeIdentifier,
      textColor: apiBox.textColor,
      textColorHover: apiBox.textColorHover,
    };
  }

  public static transformApiQuickLinkToQuickLink(apiQuickLink: IApiQuickLink, link?: string): IQuickLink {
    return {
      externalLink: apiQuickLink.externalLink,
      link: link ?? apiQuickLink.pageLink ?? `#`,
      locizeIdentifier: apiQuickLink.locizeIdentifier,
    };
  }

  public static transformApiSlideToSlide(apiSlide: IApiSlide, link?: string): ISlide {
    return {
      backgroundColor: apiSlide.backgroundColor,
      externalLink: apiSlide.externalLink,
      imageUrl: `${apiSlide.imageUrl}?w=900&auto=format`,
      link: link ?? apiSlide.pageLink ?? `#`,
      locizeIdentifier: apiSlide.locizeIdentifier,
      textColor: apiSlide.textColor,
    };
  }

  public static transformApiSocialMediaToSocialMedia(apiSocialMedia: IApiSocialMedia): ISocialMedia {
    return {
      link: apiSocialMedia.link,
      type: apiSocialMedia.type,
    };
  }
}
